export default {"src":"/_next/static/media/blob2.1a1ee92d.svg","height":140,"width":168,"blurWidth":0,"blurHeight":0};